import type * as React from 'react'
import { useState } from 'react'
import { cn } from '../../../utils'
import { ImagePreviewModal } from './ImagePreviewModal'

export type PreviewableImageProps = Omit<
  React.ImgHTMLAttributes<HTMLImageElement>,
  'onClick'
> & {
  wrapperClassName?: string
}

export function PreviewableImage({
  wrapperClassName,
  className,
  src,
  alt,
  ...imgProps
}: PreviewableImageProps) {
  const [open, setOpen] = useState(false)

  if (!src) return null

  return (
    <>
      <button
        type="button"
        className={cn(
          'block w-full h-full cursor-zoom-in bg-transparent p-0 border-0',
          'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-500 focus-visible:ring-offset-2',
          wrapperClassName
        )}
        onClick={() => setOpen(true)}
        aria-label={alt ? `预览图片：${alt}` : '预览图片'}
      >
        <img
          src={src}
          alt={alt}
          className={cn('w-full h-full', className)}
          {...imgProps}
        />
      </button>

      <ImagePreviewModal open={open} src={src} alt={alt || ''} onClose={() => setOpen(false)} />
    </>
  )
}
